import { motion } from "framer-motion";
import { Buildings, HardHat, UsersThree } from "@phosphor-icons/react";
import { SectionHeader } from "@/components/SectionHeader";
import { images } from "@/data/site";

const categories = [
  { icon: HardHat, title: "Mechanical Workforce", items: ["Mechanical Engineers & Supervisors", "Mechanical Foremen", "Fabricators", "Fitters", "Welders", "Riggers", "Operators"], testId: "manpower-skilled-card" },
  { icon: Buildings, title: "Civil Workforce", items: ["Civil Engineers", "Civil Supervisors", "Masons", "Carpenters", "Bar Benders", "Civil Helpers"], testId: "manpower-civil-card" },
  { icon: UsersThree, title: "Supporting Staff", items: ["Cook", "Office Boy", "Housekeeping Staff", "Sweeper", "General Helpers"], testId: "manpower-support-card" },
];

export function Manpower() {
  return (
    <section id="manpower" className="border-b border-industrial-line py-24 sm:py-32" data-testid="manpower-section">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <SectionHeader eyebrow="Manpower / 03" title="Site-ready people for every project phase" description="Skilled, experienced, and supporting manpower for short-term shutdowns, long-term projects, industrial plants, and civil works." testId="manpower-section-header" />
        <div className="grid gap-8 lg:grid-cols-5">
          <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="spotlight-image relative min-h-[520px] overflow-hidden border border-industrial-line lg:col-span-2" data-testid="manpower-image-panel">
            <img src={images.manpower} alt="Industrial engineers at a refinery" loading="lazy" className="h-full w-full object-cover grayscale-[25%] contrast-125" />
            <div className="absolute bottom-0 left-0 right-0 border-t border-industrial-yellow bg-white/90 p-6 backdrop-blur">
              <p className="font-heading text-3xl font-semibold uppercase text-industrial-text">Request Manpower</p>
              <p className="mt-2 text-sm text-industrial-muted">Mechanical, civil, and support teams aligned to project duration.</p>
              <a href="#contact" data-testid="manpower-request-button" className="mt-5 inline-flex items-center gap-2 bg-industrial-yellow px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em] text-industrial-black transition-transform hover:-translate-y-0.5">Request Manpower <span aria-hidden="true">↗</span></a>
            </div>
          </motion.div>
          <div className="grid gap-6 lg:col-span-3">
            {categories.map((category, index) => {
              const Icon = category.icon;
              return (
                <motion.article key={category.title} initial={{ opacity: 0, x: 36 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.12 }} className="border border-industrial-line bg-industrial-surface p-6 transition-all hover:translate-x-1 hover:border-industrial-yellow sm:p-7" data-testid={category.testId}>
                  <div className="flex flex-col gap-5 sm:flex-row">
                    <div className="flex h-14 w-14 shrink-0 items-center justify-center border border-industrial-yellow text-industrial-yellow"><Icon size={30} weight="fill" /></div>
                    <div>
                      <h3 className="font-heading text-2xl font-semibold uppercase text-industrial-text">{category.title}</h3>
                      <div className="mt-4 flex flex-wrap gap-2">
                        {category.items.map((item) => <span key={item} className="border border-industrial-line px-3 py-2 font-mono text-[11px] uppercase tracking-[0.08em] text-industrial-muted">{item}</span>)}
                      </div>
                    </div>
                  </div>
                </motion.article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
